import { render, staticRenderFns } from "./poromotion.vue?vue&type=template&id=ad86fa72&scoped=true"
import script from "./poromotion.vue?vue&type=script&lang=js"
export * from "./poromotion.vue?vue&type=script&lang=js"
import style0 from "./poromotion.vue?vue&type=style&index=0&id=ad86fa72&prod&lang=scss&scoped=true"
import style1 from "./poromotion.vue?vue&type=style&index=1&id=ad86fa72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad86fa72",
  null
  
)

export default component.exports